<template>
  <div
    v-if="!isLoading"
    class="plans-wrapper d-flex gap-md gap-md-xxl mb-xl justify-content-center align-items-center text-center">
    <div
      v-for="plan in allPlans"
      :key="plan.name">
      <h5 class="caps mb-md">
        {{ plan.tagLine }}
      </h5>
      <PlanCard :plan="plan"/>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useSubscriptionStore } from '@/stores/subscribe.js'
import PlanCard from '@/homepage/components/sections/PlansForEveryBudget/PlanCard.vue'
import { usePlans } from '@shared/composables/plans.js'

const { initializeMembershipPlans, fourItemPlan, sevenItemPlan, unlimitedPlan } = usePlans()
const { membershipPlans: membershipPlansRef } = storeToRefs(useSubscriptionStore())

const allPlans = computed(() => [fourItemPlan.value, sevenItemPlan.value, unlimitedPlan.value])
const isLoading = computed(() => !membershipPlansRef.value)
onMounted(async () => {
  await initializeMembershipPlans(true)
})
</script>

<style scoped lang="scss">
.plans-wrapper {
  flex-wrap: wrap;
}
</style>
